import { ActionReducerMap } from '@ngrx/store';

import * as fromRepairRequests from './reducers/repair-requests.reducer';
import * as fromRecommendedProducts from './reducers/recommended-products.reducer';

export interface IAppState {
  repairRequests: fromRepairRequests.IRepairRequestsState;
  recommendedProducts: fromRecommendedProducts.IRecommendedProductsState;
}

export const reducers: ActionReducerMap<IAppState> = {
  repairRequests: fromRepairRequests.repairRequestsReducer,
  recommendedProducts: fromRecommendedProducts.recommendedProductsReducer,
};
